import {
  AuditOutlined,
  BarChartOutlined,
  CalendarOutlined,
  CarOutlined,
  CloudServerOutlined,
  DesktopOutlined,
  DollarOutlined,
  GiftOutlined,
  GoldOutlined,
  HomeOutlined,
  LogoutOutlined,
  PictureOutlined,
  SelectOutlined,
  SettingOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  BarcodeOutlined,
  BuildOutlined,
  SlidersOutlined,
  OneToOneOutlined,
  EuroCircleOutlined,
  AppstoreOutlined,
  NotificationOutlined,
  PhoneOutlined,
  MessageOutlined,
  ScheduleOutlined,
  NodeIndexOutlined,
  LineChartOutlined,
  KeyOutlined,
  MedicineBoxOutlined,
  IssuesCloseOutlined,
  CheckCircleOutlined,
  AccountBookOutlined,
  FlagOutlined,
  LaptopOutlined,
  Loading3QuartersOutlined,
  BankOutlined,
  PercentageOutlined,
  ExperimentOutlined,
  YuqueOutlined,
  PayCircleOutlined,
  LoadingOutlined,
  BlockOutlined,
  BulbOutlined,
  AlertOutlined,
} from "@ant-design/icons";
import { Layout, Menu, notification, Input } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { IoCashOutline, IoLogoClosedCaptioning } from "react-icons/io5";
import SubMenu from "antd/es/menu/SubMenu";
import { logoutAdmin } from "../actions/AuthAction";
import { isPermitted } from "../utils/PermissionManager";
import {
  MdBikeScooter,
  MdDisabledVisible,
  MdPointOfSale,
  MdStar,
  MdStarBorder,
} from "react-icons/md";
import moment from "moment";
import { siteInfo } from "../utils/SiteInfo";
import { FiChevronDown, FiUserPlus } from "react-icons/fi";
//   import { sidebarItems } from "../utils/Sidebars";
const { Sider } = Layout;

export default function SideMenu(props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const path = location.pathname;
  const roles = useSelector((state) => state.auth.profile?.roles);
  let phone = useSelector((state) => state.auth.profile?.phone);
  const activated = useSelector((state) => state.auth.activated);
  const [searchQuery, setSearchQuery] = useState("");

  const q = searchQuery.toLowerCase().trim();
  const show = (label) => !q || label.toLowerCase().includes(q);
  const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
    });
  };

  const menuStyle = {
    fontSize: "16px",
    width: "18px",
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div
        style={{ padding: "12px 10px 10px 10px", flexShrink: 0 }}
        className="sidebar-search"
      >
        <Input
          placeholder="Search menus..."
          allowClear
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            width: "100%",
            borderRadius: 20,
            backgroundColor: "#f2f3f5",
            border: "none",
          }}
        />
      </div>
      <div style={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
        <Menu
          theme="light"
          mode="inline"
          defaultSelectedKeys={[path.toString()]}
          defaultOpenKeys={["accounts"]}
          style={{
            marginBottom: window?.innerWidth > 768 ? 24 : 64,
            borderRight: 0,
          }}
        >
          {show("Dashboard") && (
            <Menu.Item key={"/"} icon={<HomeOutlined style={menuStyle} />}>
              <Link to={"/"}>Dashboard</Link>
            </Menu.Item>
          )}

          {isPermitted(roles, ["super_admin", "admin"]) && activated && (
            <>
              {show("Customers") && (
                <Menu.Item
                  key={"/customers"}
                  icon={<TeamOutlined style={menuStyle} />}
                >
                  <Link to={"/customers"}>Customers</Link>
                </Menu.Item>
              )}
              {show("Orders") && (
                <Menu.Item
                  key={"/orders"}
                  icon={<GoldOutlined style={menuStyle} />}
                >
                  <Link to={"/orders"}>Orders</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["master_admin"]) && show("Ideas") && (
                <Menu.Item
                  key={"/ideas"}
                  icon={<BulbOutlined style={menuStyle} />}
                >
                  <Link to={"/ideas"}>Ideas</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["master_admin"]) &&
                show("Office Complains") && (
                  <Menu.Item
                    key={"/office-complains"}
                    icon={<AlertOutlined style={menuStyle} />}
                  >
                    <Link to={"/office-complains"}>Office Complains</Link>
                  </Menu.Item>
                )}
              {show("Slow Orders") && (
                <Menu.Item
                  key={"/report/advanced/slow-orders"}
                  icon={<MdDisabledVisible style={menuStyle} span={false} />}
                >
                  <Link to={"/report/advanced/slow-orders"}>Slow Orders</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["super_admin", "admin"]) &&
                show("Monthly Report") && (
                  <Menu.Item
                    key={"/monthly-report"}
                    icon={<CalendarOutlined style={menuStyle} />}
                  >
                    <Link to={"/monthly-report"}>Monthly Report</Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["super_admin", "admin"]) &&
                show("Active Customer") && (
                  <Menu.Item
                    key={"/customer-report"}
                    icon={<AccountBookOutlined style={menuStyle} />}
                  >
                    <Link to={"/customer-report"}>Active Customer & Slab</Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["super_admin", "admin"]) &&
                show("Inactive Customer") && (
                  <Menu.Item
                    key={"/inactive-customer-report"}
                    icon={<MdDisabledVisible style={menuStyle} />}
                  >
                    <Link to={"/inactive-customer-report"}>
                      Inactive Customer
                    </Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["super_admin", "admin"]) &&
                show("Balance Transactions") && (
                  <Menu.Item
                    key={"/balance-transactions"}
                    icon={<IoCashOutline style={menuStyle} />}
                  >
                    <Link to={"/balance-transactions"}>
                      Balance Transactions
                    </Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["super_admin", "admin"]) &&
                show("Point Customer") && (
                  <Menu.Item
                    key={"/point-customer"}
                    icon={<MdStarBorder style={menuStyle} />}
                  >
                    <Link to={"/point-customer"}>Point Customer</Link>
                  </Menu.Item>
                )}

              {isPermitted(roles, ["super_admin", "admin"]) &&
                (show("CRM Badge") ||
                  show("Monthly Report") ||
                  show("Manager Report") ||
                  show("Customer Report")) && (
                  <Menu.ItemGroup
                    key="badge-report"
                    title={
                      <div
                        style={{
                          marginLeft: 14,
                          color: siteInfo.navColor,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <span>
                          <FiUserPlus
                            style={{ ...menuStyle, marginRight: 3 }}
                          />{" "}
                          CRM Badge Report
                        </span>
                        <FiChevronDown />
                      </div>
                    }
                  >
                    {show("Badge") && (
                      <Menu.Item
                        key="/report/badge/monthly-report"
                        style={{ marginLeft: 24 }}
                      >
                        <Link to="/report/badge/monthly-report">
                          - Monthly Report
                        </Link>
                      </Menu.Item>
                    )}
                    {show("Badge Manager Report") && (
                      <Menu.Item
                        key="/report/badge/manager-report"
                        style={{ marginLeft: 24 }}
                      >
                        <Link to="/report/badge/manager-report">
                          - Manager Report
                        </Link>
                      </Menu.Item>
                    )}
                    {show("Badge Customer Report") && (
                      <Menu.Item
                        key="/report/badge/customers"
                        style={{ marginLeft: 24 }}
                      >
                        <Link to="/report/badge/customers">
                          - Customer Report
                        </Link>
                      </Menu.Item>
                    )}
                  </Menu.ItemGroup>
                )}

              {isPermitted(roles, ["super_admin"]) &&
                show("Activity Report") && (
                  <Menu.Item
                    key={"/activity-report"}
                    icon={<AuditOutlined style={menuStyle} />}
                  >
                    <Link to={"/activity-report"}>Activity Report</Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["super_admin"]) && show("Due Report") && (
                <Menu.Item
                  key={"/due-report-sa"}
                  icon={<AuditOutlined style={menuStyle} />}
                >
                  <Link to={"/due-report"}>Due Report</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["super_admin"]) && show("Unseen Report") && (
                <Menu.Item
                  key={"/unseen-report"}
                  icon={<MessageOutlined style={menuStyle} />}
                >
                  <Link to={"/unseen-report"}>Unseen Report</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["super_admin"]) &&
                show("Unreplied Report") && (
                  <Menu.Item
                    key={"/unreplied-report"}
                    icon={<MessageOutlined style={menuStyle} />}
                  >
                    <Link to={"/unreplied-report"}>Unreplied Report</Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["super_admin"]) && show("Profit Report") && (
                <Menu.Item
                  key={"/profit-report"}
                  icon={<DollarOutlined style={menuStyle} />}
                >
                  <Link to={"/profit-report"}>Profit Report</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["super_admin"]) && show("Bank Report") && (
                <Menu.Item
                  key={"/bank-report"}
                  icon={<BankOutlined style={menuStyle} />}
                >
                  <Link to={"/bank-report"}>Bank Report</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["super_admin"]) &&
                show("Investment Report") && (
                  <Menu.Item
                    key={"/investment-report"}
                    icon={<PercentageOutlined style={menuStyle} />}
                  >
                    <Link to={"/investment-report"}>Investment Report</Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["super_admin"]) &&
                show("RMB Transaction") && (
                  <Menu.Item
                    key={"/rmb-transaction-report"}
                    icon={<PayCircleOutlined style={menuStyle} />}
                  >
                    <Link to={"/rmb-transaction-report"}>
                      RMB Transaction Report
                    </Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["admin", "accountant", "delivery"]) &&
                show("Delivery Payment") && (
                  <Menu.Item
                    key={"/delivery-payment-report"}
                    icon={<CarOutlined style={menuStyle} />}
                  >
                    <Link to={"/delivery-payment-report"}>
                      Delivery Payment Report
                    </Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["super_admin", "admin"]) &&
                show("Shipments") && (
                  <Menu.Item
                    key={"/shipments"}
                    icon={<FlagOutlined style={menuStyle} />}
                  >
                    <Link to={"/shipments"}>Shipments</Link>
                  </Menu.Item>
                )}
              {/* {isPermitted(roles, ["super_admin", "admin"]) && show("Shipment Report") && (
                <Menu.Item key={"/shipment-report"} icon={<FlagOutlined style={menuStyle} />}>
                  <Link to={"/shipment-report"}>Shipment Report</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["super_admin", "admin"]) && show("Shipment VAT Report") && (
                <Menu.Item key={"/shipment-vat-report"} icon={<FlagOutlined style={menuStyle} />}>
                  <Link to={"/shipment-vat-report"}>Shipment VAT Report</Link>
                </Menu.Item>
              )} */}
              {isPermitted(roles, ["admin", "accountant", "delivery"]) &&
                show("Warehouse Courier") && (
                  <Menu.Item
                    key={"/warehouse-courier-report"}
                    icon={<GoldOutlined style={menuStyle} />}
                  >
                    <Link to={"/warehouse-courier-report"}>
                      Warehouse Courier Report
                    </Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["admin"]) && show("Purchasing Report") && (
                <Menu.Item
                  key={"/employee-purchasing-report"}
                  icon={<PictureOutlined style={menuStyle} />}
                >
                  <Link to={"/employee-purchasing-report"}>
                    Purchasing Report
                  </Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["admin"]) && show("Purchased Report") && (
                <Menu.Item
                  key={"/employee-purchase-report"}
                  icon={<DesktopOutlined style={menuStyle} />}
                >
                  <Link to={"/employee-purchase-report"}>Purchased Report</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["admin"]) && show("Purchase Cost") && (
                <Menu.Item
                  key={"/purchase-report"}
                  icon={<KeyOutlined style={menuStyle} />}
                >
                  <Link to={"/purchase-report"}>Purchase Cost Report</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["super_admin", "admin"]) &&
                show("Refund Report") && (
                  <Menu.Item
                    key={"/refund-report"}
                    icon={<LaptopOutlined style={menuStyle} />}
                  >
                    <Link to={"/refund-report"}>Refund Report</Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["admin", "accountant"]) &&
                show("Payments") && (
                  <Menu.Item
                    key={"/payments"}
                    icon={<IoCashOutline style={menuStyle} />}
                  >
                    <Link to={"/payments"}>Payments</Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["admin"]) && show("Payment Report") && (
                <Menu.Item
                  key={"/payment-report"}
                  icon={<ScheduleOutlined style={menuStyle} />}
                >
                  <Link to={"/payment-report"}>Payment Report</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["admin"]) && show("Courier Payment") && (
                <Menu.Item
                  key={"/courier-payment-report"}
                  icon={<SlidersOutlined style={menuStyle} />}
                >
                  <Link to={"/courier-payment-report"}>
                    Courier Payment Report
                  </Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["super_admin", "admin"]) &&
                show("SteadFast") && (
                  <Menu.Item
                    key={"/steadfast-report"}
                    icon={<MedicineBoxOutlined style={menuStyle} />}
                  >
                    <Link to={"/steadfast-report"}>SteadFast Report</Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["super_admin", "admin"]) &&
                show("SkyExpress") && (
                  <Menu.Item
                    key={"/skyexpress-report"}
                    icon={<MdBikeScooter style={menuStyle} />}
                  >
                    <Link to={"/skyexpress-report"}>SkyExpress Report</Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["admin"]) && show("Gateway Report") && (
                <Menu.Item
                  key={"/gateway-report"}
                  icon={<NodeIndexOutlined style={menuStyle} />}
                >
                  <Link to={"/gateway-report"}>Gateway Report</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["admin"]) && show("Cash Report") && (
                <Menu.Item
                  key={"/cash-report"}
                  icon={<LineChartOutlined style={menuStyle} />}
                >
                  <Link to={"/cash-report"}>Cash Report</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["admin"]) && show("Call Report") && (
                <Menu.Item
                  key={"/call-report"}
                  icon={<PhoneOutlined style={menuStyle} />}
                >
                  <Link to={"/call-report"}>Call Report</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["admin"]) && show("Call Task") && (
                <Menu.Item
                  key={"/call-task-report"}
                  icon={<PhoneOutlined style={menuStyle} />}
                >
                  <Link to={"/call-task-report"}>Call Task Report</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["admin"]) &&
                show("Advance Status Timeline") && (
                  <Menu.Item
                    key={"/advanced-status-timeline"}
                    icon={<SlidersOutlined style={menuStyle} />}
                  >
                    <Link to={"/advanced-status-timeline"}>
                      Advance Status Timeline
                    </Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["admin"]) && show("Due Report") && (
                <Menu.Item
                  key={"/due-report"}
                  icon={<DollarOutlined style={menuStyle} />}
                >
                  <Link to={"/due-report"}>Due Report</Link>
                </Menu.Item>
              )}
              {isPermitted(roles, ["master_admin"]) &&
                show("Bcommerce Payment") && (
                  <Menu.Item
                    key={"/bcommerce-payment"}
                    icon={<DollarOutlined style={menuStyle} />}
                  >
                    <Link to={"/bcommerce-payment"}>Bcommerce Payment</Link>
                  </Menu.Item>
                )}
              {isPermitted(roles, ["admin"]) && show("Sms Report") && (
                <Menu.Item
                  key={"/sms-report"}
                  icon={<MessageOutlined style={menuStyle} />}
                >
                  <Link to={"/sms-report"}>Sms Report</Link>
                </Menu.Item>
              )}
            </>
          )}

          {show("Profile") && (
            <Menu.Item
              key="/SettingOutlined"
              icon={
                <UserOutlined style={{ fontSize: "14px", width: "18px" }} />
              }
            >
              <Link to={"/profile"}>Profile</Link>
            </Menu.Item>
          )}
          {show("Logout") && (
            <Menu.Item
              key="/logout"
              onClick={() => {
                dispatch(logoutAdmin(() => {}));
                openNotificationWithIcon(
                  "success",
                  "Success",
                  "Logged out successfully",
                );
              }}
              icon={
                <LogoutOutlined style={{ fontSize: "16px", width: "18px" }} />
              }
            >
              Logout
            </Menu.Item>
          )}
        </Menu>
      </div>
    </div>
  );
}
